var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompany(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56C43.464 56 56 43.464 56 28Z",
    fill: "#6A76F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8543 15.1301H19.5957V19.413H25.8543V15.1301Z",
    fill: "#959EF7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.59 15.1301H19.2031V19.348H22.59V15.1301Z",
    fill: "#07127D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7195 15.1301H28.4609V19.413H34.7195V15.1301Z",
    fill: "#959EF7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2244 40.8699H26.8828V25.8339L31.2631 19.3513H37.2025L41.2244 25.8339V40.8699Z",
    fill: "#959EF7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4498 19.3513H16.733L12.5957 25.8339V40.8699H26.9384V25.8339H26.8824L31.4498 19.3513Z",
    fill: "#07127D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4513 15.1301H28.0645V19.348H31.4513V15.1301Z",
    fill: "#07127D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6172 40.8698C38.6172 40.1525 38.9022 39.4645 39.4094 38.9573C39.9167 38.45 40.6046 38.165 41.322 38.165C42.0393 38.165 42.7273 38.45 43.2346 38.9573C43.7418 39.4645 44.0268 40.1525 44.0268 40.8698",
    fill: "#07127D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.44 40.87C36.434 40.6284 36.4764 40.3881 36.5647 40.1632C36.653 39.9383 36.7854 39.7333 36.9541 39.5604C37.1228 39.3874 37.3244 39.25 37.547 39.1561C37.7697 39.0623 38.0089 39.0139 38.2505 39.0139C38.4921 39.0139 38.7313 39.0623 38.9539 39.1561C39.1766 39.25 39.3782 39.3874 39.5469 39.5604C39.7156 39.7333 39.848 39.9383 39.9363 40.1632C40.0246 40.3881 40.067 40.6284 40.061 40.87",
    fill: "#07127D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3892 40.87C42.3832 40.6284 42.4256 40.3881 42.5139 40.1632C42.6022 39.9383 42.7346 39.7333 42.9033 39.5604C43.072 39.3874 43.2736 39.25 43.4963 39.1561C43.7189 39.0623 43.9581 39.0139 44.1997 39.0139C44.4413 39.0139 44.6805 39.0623 44.9032 39.1561C45.1258 39.25 45.3274 39.3874 45.4961 39.5604C45.6648 39.7333 45.7972 39.9383 45.8855 40.1632C45.9738 40.3881 46.0162 40.6284 46.0102 40.87",
    fill: "#07127D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1685 40.8697C12.1612 40.5099 12.2257 40.1523 12.3584 39.8178C12.491 39.4833 12.689 39.1787 12.9408 38.9216C13.1927 38.6646 13.4933 38.4604 13.825 38.3211C14.1567 38.1817 14.5129 38.1099 14.8728 38.1099C15.2326 38.1099 15.5888 38.1817 15.9205 38.3211C16.2523 38.4604 16.5529 38.6646 16.8047 38.9216C17.0565 39.1787 17.2546 39.4833 17.3872 39.8178C17.5198 40.1523 17.5843 40.5099 17.577 40.8697",
    fill: "#959EF7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99079 40.87C9.98479 40.6284 10.0272 40.3881 10.1155 40.1632C10.2037 39.9383 10.3361 39.7333 10.5049 39.5604C10.6736 39.3874 10.8752 39.25 11.0978 39.1561C11.3205 39.0623 11.5597 39.0139 11.8013 39.0139C12.0429 39.0139 12.2821 39.0623 12.5047 39.1561C12.7274 39.25 12.929 39.3874 13.0977 39.5604C13.2664 39.7333 13.3988 39.9383 13.4871 40.1632C13.5754 40.3881 13.6178 40.6284 13.6118 40.87",
    fill: "#959EF7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.94 40.87C15.934 40.6284 15.9764 40.3881 16.0647 40.1632C16.153 39.9383 16.2854 39.7333 16.4541 39.5604C16.6228 39.3874 16.8244 39.25 17.047 39.1561C17.2697 39.0623 17.5089 39.0139 17.7505 39.0139C17.9921 39.0139 18.2313 39.0623 18.4539 39.1561C18.6766 39.25 18.8782 39.3874 19.0469 39.5604C19.2156 39.7333 19.348 39.9383 19.4363 40.1632C19.5246 40.3881 19.567 40.6284 19.561 40.87",
    fill: "#959EF7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3037 28H16.3984V30.9702H19.3037V28Z",
    fill: "#959EF7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.794 28H19.8887V30.9702H22.794V28Z",
    fill: "#959EF7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3037 31.5583H16.3984V34.5286H19.3037V31.5583Z",
    fill: "#959EF7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.794 31.5583H19.8887V34.5286H22.794V31.5583Z",
    fill: "#959EF7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.fc4dd370.svg";
export { ForwardRef as ReactComponent };